import React from 'react';

import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NewsLayout, PageLayout, PagePath } from '@/layouts/shared';
import withAuthServerSideProps from '@/libs/auth';
import { fetchBlogs, fetchNews, fetchNewsBySlug } from '@/features/blog/api';
import { IArticle, IRelatedProduct } from '@/features/article';
import { JournalArticleLayout } from '@/features/journal/article';
import { fetchProductsByIds } from '@/features/products/list/api';
import { classify, findSeedPost } from '@/features/journal/data';

const BlogPage = (props: IArticle & { topicSlug?: string | null }) => (
  <JournalArticleLayout {...props} cover={props.article.acf?.layout === NewsLayout.PromotionsLayout} />
);

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale, query }: GetServerSidePropsContext) => {
    try {
      const { id } = query;
      const { data } = await fetchNewsBySlug(id + '');
      // bài soạn sẵn (features/journal/seed) hiển thị tạm khi anthu.today chưa có bài cùng slug
      const article = data[0] || findSeedPost(id + '');
      if (!article) throw new Error('not found');
      let products: IRelatedProduct[] = [];
      if (article.acf?.related_products) {
        const { data: relatedProducts } = await fetchProductsByIds(article.acf.related_products);
        products = relatedProducts;
      }
      const { data: newArticles } = await fetchNews({ page: 1, per_page: 5 });
      const { data: blogs } = await fetchBlogs();
      return {
        props: {
          article,
          layout: PageLayout.Journal,
          topicSlug: classify({ slug: article.slug, title: String(article.title?.rendered || '').replace(/<[^>]*>/g, ''), categories: article.categories || [] })[0] || null,
          products,
          newArticles,
          blogs,
          ...(await serverSideTranslations(locale as string, ['layout', 'product', 'consult', 'order'])),
        },
      };
    } catch (_) {
      return {
        redirect: {
          permanent: false,
          destination: PagePath.HomePage,
        },
      };
    }
  },
  { isAntiAuth: false, isPublic: true }
);
export default BlogPage;
